module.exports = __webpack_public_path__ + "img/slovenia.c7812a6f.svg";